import { MapTilerBaseLayerBase } from "./MapTilerBaseLayerBase";
export class ShortCutClassicLayer extends MapTilerBaseLayerBase {
    constructor() {
        super(ShortCutClassicLayer.Url);
    }
    onAfterFetch(style) {
        // update oneway arrows.
        MapTilerBaseLayerBase.removeLayers(style, ["road_oneway", "road_oneway_opposite"]);
        MapTilerBaseLayerBase.addLayer(style, {
            id: "road-oneway",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            "layout": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-size": {
                    "stops": [
                        [
                            15,
                            0.5
                        ],
                        [
                            19,
                            1
                        ]
                    ]
                },
                "text-font": [],
                "icon-image": "oneway",
                "icon-rotate": 90,
                "icon-padding": 2,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map"
            },
            "paint": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-opacity": 0.5
            },
            filter: MapTilerBaseLayerBase.IsOnewayFilter()
        }, "label_airport");
        MapTilerBaseLayerBase.addLayer(style, {
            id: "road-oneway-reverse",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            "layout": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-size": {
                    "stops": [
                        [
                            15,
                            0.5
                        ],
                        [
                            19,
                            1
                        ]
                    ]
                },
                "text-font": [],
                "icon-image": "oneway",
                "icon-rotate": -90,
                "icon-padding": 2,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map"
            },
            "paint": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-opacity": 0.5
            },
            filter: MapTilerBaseLayerBase.IsOnewayReverseFilter()
        }, "road-oneway");
    }
}
ShortCutClassicLayer.Url = "https://api.maptiler.com/maps/243003a5-bfac-470e-85a3-cc6f3be8edb0/style.json?key=OZUCIh4RNx38vXF8gF4H";
